export const FirebaseConfig = {
	"projectId": "niljyoti-f7685",
	"appId": "1:752220213855:web:6d158f0c34335f63ddc1ea",
	"databaseURL": "https://niljyoti-f7685-default-rtdb.firebaseio.com",
	"storageBucket": "niljyoti-f7685.firebasestorage.app",
	"apiKey": "AIzaSyD-_4jHJmJinvvLqqz5NDIxx27EqHn40_A",
	"authDomain": "niljyoti-f7685.firebaseapp.com",
	"messagingSenderId": "752220213855",
	"measurementId": "G-DCW9S0Q7L2",
	"projectNumber": "752220213855",
	"version": "2"
};